export var MultichainActionType;
(function (MultichainActionType) {
    MultichainActionType["TEST_MSG"] = "TEST_MSG";
    MultichainActionType["SET_MK"] = "SET_MK";
    // ERROR ACTIONS
    MultichainActionType["SET_MESSAGE"] = "SET_MESSAGE";
    // MODAL ACTIONS
    MultichainActionType["OPEN_MODAL"] = "OPEN_MODAL";
    MultichainActionType["CLOSE_MODAL"] = "CLOSE_MODAL";
    // NAVIGATION ACTIONS
    MultichainActionType["NAVIGATE_TO"] = "NAVIGATE_TO";
    MultichainActionType["NAVIGATE_TO_WITH_PARAMS"] = "NAVIGATE_TO_WITH_PARAMS";
    MultichainActionType["GO_BACK"] = "GO_BACK";
    MultichainActionType["RESET_NAV"] = "RESET_NAV";
    MultichainActionType["GO_BACK_TO_THEN_NAVIGATE"] = "GO_BACK_TO_THEN_NAVIGATE";
    // LOADING
    MultichainActionType["SET_LOADING"] = "SET_LOADING";
    MultichainActionType["ADD_TO_LOADING_LIST"] = "ADD_TO_LOADING_LIST";
    MultichainActionType["REMOVE_FROM_LOADING_LIST"] = "REMOVE_FROM_LOADING_LIST";
    MultichainActionType["ADD_CAPTION_TO_LOADING_PAGE"] = "ADD_CAPTION_TO_LOADING_PAGE";
    MultichainActionType["ADD_LOADING_PERCENTAGE"] = "ADD_LOADING_PERCENTAGE";
    // TITLE CONTAINER
    MultichainActionType["SET_TITLE_PROPERTIES"] = "SET_TITLE_PROPERTIES";
    MultichainActionType["RESET_TITLE_PROPERTIES"] = "RESET_ACTION_PROPERTIES";
    MultichainActionType["SET_HAS_FINISHED_SIGNUP"] = "SET_HAS_FINISHED_SIGNUP";
})(MultichainActionType || (MultichainActionType = {}));
